import React, { useMemo } from 'react'
import type { UseListResult } from '@ztechapps/common.hook'
import { useList } from '@ztechapps/common.hook'
import isEmpty from 'lodash/isEmpty'
import type { Task } from '@ztechapps/common.contract'
import { useTaskFilterBarContext } from '../TaskFilterBar'
import { TaskViewMode, taskDocumentQueries } from '@ztechapps/task.common'

type CalendarDate = { currentStart?: Date; currentEnd?: Date }

export type UseGetTaskLists = {
  list: Task[]
  setCalendarDate: (date: CalendarDate) => void
  calendarDate: CalendarDate
  loading: boolean
} & UseListResult

export const useGetTaskLists = (): UseGetTaskLists => {
  const { mongoFilter, viewMode } = useTaskFilterBarContext()
  const [calendarDate, setCalendarDate] = React.useState<CalendarDate>({})

  // Merge shared filter with calendar date filter when in calendar view
  const mergedFilter = useMemo(() => {
    const base = { ...mongoFilter }

    if (viewMode === TaskViewMode.Calendar && !isEmpty(calendarDate)) {
      base.startDate = { $gte: calendarDate?.currentStart, $lt: calendarDate?.currentEnd }
    }

    return base
  }, [mongoFilter, viewMode, calendarDate])

  const listResult = useList<Task>({
    ...taskDocumentQueries.allConfig,
    limit: 0,
    filter: mergedFilter,
    sort: {
      createdAt: 1,
    },
    subscribeToUpdates: true,
  })

  return { setCalendarDate, calendarDate, ...listResult }
}
